var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncreaseSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 18.2571L36.2571 3.31429M36.2571 3.31429L30.1143 1M36.2571 3.31429L33.9714 9.45714M37.7143 38.1429H30.5714V18.1429C30.5714 17.764 30.7219 17.4006 30.9898 17.1327C31.2578 16.8648 31.6211 16.7143 32 16.7143H36.2857C36.6646 16.7143 37.028 16.8648 37.2959 17.1327C37.5638 17.4006 37.7143 17.764 37.7143 18.1429V38.1429ZM23.4286 38.1429H16.2857V22.4286C16.2857 22.0497 16.4362 21.6863 16.7041 21.4184C16.972 21.1505 17.3354 21 17.7143 21H22C22.3789 21 22.7422 21.1505 23.0102 21.4184C23.2781 21.6863 23.4286 22.0497 23.4286 22.4286V38.1429ZM9.14286 38.1429H2V26.7143C2 26.3354 2.15051 25.972 2.41842 25.7041C2.68633 25.4362 3.04969 25.2857 3.42857 25.2857H7.71429C8.09317 25.2857 8.45653 25.4362 8.72444 25.7041C8.99235 25.972 9.14286 26.3354 9.14286 26.7143V38.1429Z",
    stroke: "currentcolor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncreaseSales);
export default __webpack_public_path__ + "static/media/icon-increase-sales.b8f5577b073f0e65e273d07eb6aa18fb.svg";
export { ForwardRef as ReactComponent };